import tw, { styled, css } from 'twin.macro';

export const StyledContainer = styled.div`
  ${tw`flex items-center gap-[10px]`}
`;

export const StyledStarContainer = styled.div`
  ${tw`relative`}
`;

export const StyledStarList = styled.div`
  ${tw`flex gap-[4px] items-center`}
`;

export const StyledStarFilled = styled(StyledStarList)`
  ${tw`absolute top-0`}
  ${tw`overflow-hidden`}
  ${tw`whitespace-nowrap`}
`;

export const StyledStarIcon = styled.div<{ isFilled?: boolean; icon: string }>`
  ${tw`inline-block`}
  ${tw`w-16 min-w-[16px] h-2`}
  ${tw`[mask-size:cover]`}

  ${({ isFilled }) => (isFilled ? tw`bg-[#F4BC39]` : tw`bg-neutrals-n5`)}
  ${({ icon }) =>
    icon &&
    css`
      mask-image: url(${icon});
    `}
`;

export const StyledLabel = styled.p`
  ${tw`text-text-cta text-primary-p1`}
  ${tw`font-inter font-semi-bold`}
`;

export const StyledImage = styled.img`
  ${tw`w-[30px] h-[30px]`}
`;
